import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./PendingApprovals.module.css";
import imageWhite from "../../assets/images/dashboard/list-of-invoice-white.svg";
import { TableOptions } from "../../utils/messageConstants";
import { Link } from "react-router-dom";

let order = "desc";

export class PendingApprovals extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleBtnClick = () => {
    if (order === "desc") {
      this.refs.table.handleSort("asc", "name");
      order = "asc";
    } else {
      this.refs.table.handleSort("desc", "name");
      order = "desc";
    }
  };

  render() {
    const dashboardCountData = this.props.dashboardCounts;
    return (
      <div>
        <div className={`card ${style.pendingApprovalCard}`}>
          <Link to="/app/pendingapprovallist">
          <div className={`card-header ${style.pendingApprovalHeader}`}>
            <div className="d-flex align-items-center dashboard-list-box">
              <img src={imageWhite} alt="Pending Approvals" />
              Pending Approvals
            </div>
            <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
          </div>
          <div className="card-body dashboard-time-table-wrapper">
            <BootstrapTable ref="table" data={dashboardCountData.pendingApprovals} options={TableOptions} version="4">
              <TableHeaderColumn
                dataField="party_name"
                isKey={true}
                // dataSort={true}
                width={"50%"}
              >
                Contact Name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="raisedRequestBy"
                // dataSort={true}
                width={"50%"}
              >
                Raised By
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
          </Link>
        </div>
      </div>
    );
  }
}


export default PendingApprovals;

